import React, { useState } from "react";
import { Line, Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  RadialLinearScale,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  RadialLinearScale,
  Tooltip,
  Legend
);

export default function KTHubHome() {

  const [budget,setBudget] = useState(40)
  const productivity = (budget * 0.25).toFixed(1)
  const knowledgeGraphData = {
    labels: [
      "CNC Machine",
      "Injection Molding",
      "Inspection",
      "Senior Operator",
      "Plant Engineer",
      "QA Lead"
    ],
    datasets: [
      {
        label: "Knowledge Connections",
        data: [6,5,4,7,6,5],
        borderColor: "#22c55e",
        backgroundColor: "rgba(34,197,94,0.2)"
      }
    ]
  };

  const skillMatrixData = {
    labels: [
      "CNC",
      "Inspection",
      "Maintenance",
      "Assembly",
      "Quality",
      "Molding"
    ],
    datasets: [
      {
        label: "Operator Skill Level",
        data: [4,3,2,4,3,4],
        borderColor: "#38bdf8",
        backgroundColor: "rgba(56,189,248,0.3)"
      }
    ]
  };

  return (

    <div className="min-h-screen bg-black text-white px-4 py-6 [&_p]:text-white">
        <div className="mb-6">
            <h1 className="text-xl font-bold">Think5Whys Knowledge Transformation Engine</h1>
            <p className="text-gray-400 text-sm">KT Hub • Root Cause Intelligence • Factory Learning</p>
        </div>

        <div className="grid grid-cols-2 gap-3 mb-4">
            <div className="bg-zinc-900 p-4 rounded">
                <p className="text-2xl font-bold">36</p>
                <p className="text-xs text-gray-400">Active KT</p>
            </div>
            <div className="bg-zinc-900 p-4 rounded">
                <p className="text-2xl font-bold">128</p>
                <p className="text-xs text-gray-400">Knowledge Assets</p>
            </div>
            <div className="bg-zinc-900 p-4 rounded">
                <p className="text-2xl font-bold">52</p>
                <p className="text-xs text-gray-400">Certified Operators</p>
            </div>
            <div className="bg-zinc-900 p-4 rounded">
                <p className="text-2xl font-bold">14</p>
                <p className="text-xs text-gray-400">Open Root Causes</p>
            </div>
        </div>

        <h2 className="text-lg font-semibold mb-3 text-yellow-300">KT Operations</h2>

        <div className="grid grid-cols-1 gap-3 mb-4">
            {[
            "KT Initiation",
            "Tacit Knowledge Capture",
            "SOP Repository",
            "Machine Knowledge",
            "5 Whys Root Cause Library",
            "Training & Certification",
            "KT Progress Tracker",
            "Factory Knowledge Graph"
            ].map((item,i)=>(

            <div key={i} className="text-gray-200 bg-zinc-900 p-4 rounded flex justify-between items-center">
                <span>{item}</span>
                <button className="w-24 lg:w-32 bg-green-600 text-xs px-3 py-1 rounded">Open</button>
            </div>
            ))}
        </div>

        <h2 className="text-lg font-semibold mb-3 text-yellow-300">AI Troubleshooting Search</h2>
        <div className="bg-zinc-900 p-4 rounded mb-4">
            <input className="w-full p-2 rounded bg-black border border-zinc-700 mb-2"
            placeholder="Search problem e.g surface defect..."
            />
            <button className="w-24 lg:w-32 bg-green-600 px-4 py-2 text-sm rounded">Search Knowledge</button>
            <p className="text-xs text-gray-400 mt-2">Results connect SOP, root cause and expert knowledge.</p>
        </div>

        <h2 className="text-lg font-semibold mb-3 text-yellow-300">Knowledge Graph</h2>
        <div className="bg-zinc-900 p-4 rounded mb-4 w-full">
            <Line data={knowledgeGraphData} />
        </div>

        <h2 className="text-lg font-semibold mb-3 text-yellow-300">Training Investment Simulation</h2>
        <div className="bg-zinc-900 p-4 rounded mb-4">
            <input
            type="range"
            min="1"
            max="100"
            value={budget}
            onChange={(e)=>setBudget(e.target.value)}
            className="w-full"
            />
            <p className="mt-2 text-sm">Estimated Productivity Gain : {productivity} %</p>
        </div>

        <h2 className="text-lg font-semibold mb-3 text-yellow-300">Operator Skill Matrix</h2>
        <div className="bg-zinc-900 p-4 rounded mb-4 w-full">
            <Radar data={skillMatrixData} />
        </div>

        <h2 className="text-lg font-semibold mb-3 text-yellow-300" >Expert Marketplace</h2>
        <div className="grid grid-cols-1 gap-3 mb-4">
            {[
            "Senior CNC Expert",
            "Injection Molding Engineer",
            "Quality Specialist"
            ].map((expert,i)=>(

            <div key={i} className="text-gray-200 bg-zinc-900 p-4 rounded flex justify-between">
                <span>{expert}</span>
                <button className="w-24 lg:w-32 bg-green-600 px-3 py-1 text-xs rounded">Request</button>
            </div>
            ))}
        </div>

        <h2 className="text-lg font-semibold mb-3 text-yellow-300">Video SOP</h2>
        <div className="bg-zinc-900 p-4 rounded mb-4">
            <p className="text-sm mb-2">CNC Tool Calibration</p>
            <video controls className="w-full rounded"><source src="/sample.mp4" type="video/mp4" /></video>
        </div>

        <h2 className="text-lg font-semibold mb-3 text-yellow-300">Recent Knowledge Assets</h2>
        <div className="bg-zinc-900 rounded p-4 text-sm">
            <div className="border-b border-zinc-700 pb-2 mb-2">CNC Calibration Guide • SOP</div>
            <div className="border-b border-zinc-700 pb-2 mb-2">Molding Pressure Adjustment • Video</div>
            <div>Surface Defect RCA • 5 Whys</div>
        </div>
    </div>
  );
}